var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qn-upload"
  }, [_c('el-upload', _vm._b({
    ref: "upload",
    attrs: {
      "action": _vm.action,
      "accept": _vm.accept,
      "auto-upload": _vm.autoUpload,
      "max-length": _vm.maxLength,
      "on-change": _vm.handleChange,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.handleBeforeUpload,
      "http-request": _vm.handleUpload,
      "list-type": _vm.listType,
      "file-list": _vm.fileList
    }
  }, 'el-upload', _vm.$attrs, false), [_vm._l((_vm.$slots), function(index, name) {
    return _c('template', {
      slot: name
    }, [_vm._t(name)], 2)
  }), _vm._v(" "), (_vm.listType === 'picture-card') ? [(!_vm.$slots.default) ? _c('i', {
    staticClass: "el-icon-plus"
  }) : _vm._e(), _vm._v(" "), (!_vm.$slots.tip) ? _c('div', {
    staticClass: "el-upload__tip",
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tip))]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('preview', {
    attrs: {
      "visible": _vm.dialogs.preview,
      "data": _vm.preview.data,
      "is-edit": _vm.isCropper,
      "list": _vm.preview.list
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogs.preview = $event
      },
      "edit": _vm.handleToEdit
    }
  }), _vm._v(" "), (_vm.isCropper) ? _c('cropper', {
    attrs: {
      "visible": _vm.dialogs.cropper,
      "data": _vm.cropper.data,
      "resolution": _vm.cropper.resolution
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogs.cropper = $event
      },
      "success": _vm.handleCropper
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7ec3b6ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ec3b6ec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QnUpload-1.0.0/index.vue
// module id = m52m
// module chunks = 212